/**
 * Created by Andrey Popov on 08.08.25
 */

const Stock = function () {
    this.data = {};
};

Stock.prototype.onUnitAvailable = function (unit) {
    if (Stock.IGNORES_STOCK.indexOf(unit.code) !== -1 || unit.isGrounded()) {
        return;
    }

    if (unit.stocked > 0) {
        // cleverapps.throwAsync(`Unit added second time ${Unit.GetKey(unit)}`);
        return;
    }

    const key = Unit.GetKey(unit);

    const mapUnit = Merge2.current.field.getUnit(unit.x, unit.y);
    if (!mapUnit || Unit.GetKey(mapUnit) !== key) {
        return;
    }

    this.data[key] = (this.data[key] || 0) + 1;

    unit.stocked = 1;

    this.onChanged();
};

Stock.prototype.onUnitRemoved = function (unit) {
    if (unit.stocked < 1) {
        // cleverapps.throwAsync(`Unit removed second time ${Unit.GetKey(unit)}`);
        return;
    }

    if (!unit.stocked) {
        return;
    }

    const key = Unit.GetKey(unit);
    this.data[key] = (this.data[key] || 0) - 1;

    unit.stocked -= 1;

    this.onChanged();
};

Stock.prototype.onBackpackChanged = function () {
    this.onChanged();
};

Stock.prototype.onChanged = function () {
    Merge2.current.customers.updateMarks();
    Merge2.current.customers.onRecipesUpdated();
};

Stock.prototype.getStockAmount = function (ingredient) {
    if (ingredient.unit) {
        const key = Unit.GetKey(ingredient.unit);
        return (this.data[key] || 0) + Merge2.current.backpack.countUnits(key);
    }

    return 0;
};

Stock.prototype.pickUnits = function (amounts) {
    amounts = { ...amounts };
    const units = [];

    const pick = (filter) => {
        Merge2.current.field.listAvailableUnits((unit) => {
            const key = Unit.GetKey(unit);
            if (unit.stocked && amounts[key] > 0 && filter(unit)) {
                amounts[key] -= 1;
                units.push(unit);
            }
        });
    };

    pick((unit) => unit.customerMark);
    pick((unit) => !unit.customerMark);

    const backpackIndexes = Merge2.current.backpack.pickUnits(amounts);

    return { units, backpackIndexes };
};

Stock.prototype.takeIngredients = function (ingredients, options) {
    options = options || {};
    const customer = options.customer;
    const callback = options.callback || function () {};

    const amounts = {};

    ingredients.forEach((ingredient) => {
        if (ingredient.unit) {
            amounts[Unit.GetKey(ingredient.unit)] = ingredient.amount;
        }
    });

    const { units, backpackIndexes } = this.pickUnits(amounts);

    Merge2.current.counter.inc();
    const waitCallback = cleverapps.wait(units.length + backpackIndexes.length, () => {
        callback();
        Merge2.current.counter.dec();
    });

    units.forEach((unit) => {
        customer.collectUnit(unit, waitCallback);
    });

    backpackIndexes.forEach((index) => {
        customer.collectBackpackUnit(index, waitCallback);
    });
};

Stock.prototype.canTakeIngredients = function (ingredients) {
    for (let i = 0; i < ingredients.length; i++) {
        const ingredient = ingredients[i];

        if (this.getStockAmount(ingredient) < ingredient.amount) {
            return false;
        }
    }
    return true;
};

Stock.prototype.getLackingAmount = function (ingredient) {
    return Math.max(0, ingredient.amount - this.getStockAmount(ingredient));
};

Stock.prototype.getLackingUnits = function (ingredients) {
    const units = [];
    for (let i = 0; i < ingredients.length; i++) {
        const ingredient = ingredients[i];
        const amount = this.getLackingAmount(ingredient);
        
        for (let j = 0; j < amount; ++j) {
            units.push({ code: ingredient.unit.code, stage: ingredient.unit.stage });
        }
    }
    return units;
};

Stock.prototype.canSpawnIngredients = function (ingredients) {
    const unitsAmount = ingredients.reduce((total, ingredient) => {
        if (ingredient.unit) {
            return total + this.getLackingAmount(ingredient);
        }
        return total;
    }, 0);

    const cellsToFree = unitsAmount - Merge2.current.field.countEmptySlots();

    if (cellsToFree > 0) {
        cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left: cellsToFree }));
        return false;
    }
    return true;
};

Stock.prototype.spawnIngredients = function (ingredients) {
    const cell = Merge2.current.field.getScreenCenterCell();

    this.getLackingUnits(ingredients).forEach((item) => {
        const slot = Merge2.current.field.findEmptySlot(cell.x, cell.y);

        const unit = new Unit(item);
        unit.setPosition(slot.x, slot.y);
        Merge2.current.field.addUnit(unit.x, unit.y, unit);
        Merge2.current.field.onAddUnit(unit.x, unit.y, unit);
        Merge2.current.field.onUnitAvailable(unit);
    });
};

Stock.prototype.getUnits = function (ingredients, lacking) {
    const cell = Merge2.current.field.getScreenCenterCell();

    for (let i = 0; i < ingredients.length; i++) {
        const ingredient = ingredients[i];
        const amount = lacking ? this.getLackingAmount(ingredient) : ingredient.amount;

        if (ingredient.unit) {
            for (let j = 0; j < amount; ++j) {
                const slot = Merge2.current.field.findEmptySlot(cell.x, cell.y);

                const unit = new Unit(ingredient.unit);
                unit.setPosition(slot.x, slot.y);
                Merge2.current.field.addUnit(unit.x, unit.y, unit);
                Merge2.current.field.onAddUnit(unit.x, unit.y, unit);
                Merge2.current.field.onUnitAvailable(unit);
            }
        }
    }
};

Stock.IGNORES_STOCK = ["unknown", "thirdelement"];
